<template>
  <Survey />
</template>

<script>
// @ is an alias to /src
import Survey from '@/components/Survey.vue'

export default {
  name: 'Home',
  components: {
    Survey
  },
  created() {
    document.title = 'GloryFeel YouGuide'
  }
}
</script>

<style>
.survey-wrapper a{
  text-decoration: none!important;
}

.survey-wrapper .product--title {
    min-height: 56px;
}
</style>
